export enum PropPosition {
    POSITION = 'position',
    SECTION_POSITION = 'section_position',
    MATRIX_POSITION = 'matrix_position',
    CHOICE_POSITION = 'choice_position'
}


// WEBPACK FOOTER //
// ./common/src/main/resources/ts/core/enums/prop-position.ts